//Replicate for stage and prod
export const environment = {
  production: false,
  environment: 'dev',
  title: 'Sierra Inventory',
  name: 'sierra-inventory',
  features: {
    kardexDashboard: true,
  },
  proxyUrls: {
    assetApi: 'https://asset.api.dev.sierra-erp.com',
    itemApi: 'https://item.api.dev.sierra-erp.com',
    userMasterApi: 'https://user.api.dev.sierra-erp.com',
    inventoryApi: 'https://inventory.api.dev.sierra-erp.com',
    orderApi: 'https://order.api.dev.sierra-erp.com',
    productionApi: 'https://production.api.dev.sierra-erp.com',
    financeApi: 'https://finance.api.dev.sierra-erp.com',
    reportApi: 'https://reportgenerator.dev.sierra-erp.com',
  },
  externalSitesUrls: {
    itemModule: 'sierra.textiles.come',
  },
  domainUrl: {
    order: 'https://www.order-dev.sierra-erp.com',
    production: 'https://www.production-dev.sierra-erp.com',
  },
};
